import * as React from "react";
import * as ReactDOM from "react-dom";
import { EmailSubscriptionInfo } from '../Generated/RestClient';
import { resourceStrings } from "../../../Intercom.ReactUI/Views/Strings";
import { ProgressRingControl } from "../../../Intercom.ReactUI/Views/ProgressRingControl";
import { EmailSubscriptionConsentFormFields } from './EmailSubscriptionConsentFormFields';
import { UserAgreementConsentFormFields } from './UserAgreementConsentFormFields';

export interface EmailSubscriptionConsentFormProps extends React.Props<EmailSubscriptionConsentForm> {
    subscriptionInfo: EmailSubscriptionInfo;
    askUserAgreement: boolean;
    onSave?: (EmailSubscriptionInfo) => any;
    onCancel?: (EmailSubscriptionInfo) => any;
}

export interface EmailSubscriptionConsentFormState {
    saveButtonEnabled?: boolean;
    enabled?: boolean;
}

export class EmailSubscriptionConsentForm extends React.Component<EmailSubscriptionConsentFormProps, EmailSubscriptionConsentFormState> {
    constructor(props?: EmailSubscriptionConsentFormProps, context?: any) {
        super(props, context);
        if (this.props.askUserAgreement) {
            this.state = {
                saveButtonEnabled: false,
                enabled: false
            };
        } else {
            this.state = {
                saveButtonEnabled: true,
                enabled: false
            }
        }
    }

    private onAgreementChanged = (enabled: boolean) => {
        let mutatedState = _.extend({}, this.state) as EmailSubscriptionConsentFormState;
        if (mutatedState) {
            mutatedState.saveButtonEnabled = enabled;
        }

        this.setState(mutatedState);
    }

    private onCancelClicked = (e: React.FormEvent<any>) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.onCancel) {
            this.props.onCancel(_.extend({}, this.props.subscriptionInfo))
        }
    }

    private onSubmitClicked = (e: React.FormEvent<any>) => {
        e.preventDefault();
        e.stopPropagation();

        if (!this.state.saveButtonEnabled) {
            return;
        }

        // need Country Code or there is a server error
        if (this.props.subscriptionInfo && !this.props.subscriptionInfo.CountryCode) {
            $('#country-select').addClass('must-check');
            return;
        }

        if (this.props.onSave) {
            this.props.onSave(_.extend({}, this.props.subscriptionInfo))
        }
    }

    private renderBusy(): JSX.Element {
        return <div className="email-consent-form">
            <ProgressRingControl />
        </div>;
    }

    private renderHeaderPrefixes(): JSX.Element[] {
        if ( this.props.subscriptionInfo ) {
            return [
                <h1 className="form-heading" key="form-header">
                    {resourceStrings.subscriptionConsentDialog.title}
                </h1>,

                <p className="form-description" key="form-description">
                    {resourceStrings.subscriptionConsentDialog.description}
                </p>
            ];
        }

        return [
            <h1 className="form-heading" key="form-header">
                {resourceStrings.subscriptionConsentDialog.agreementHeading}
            </h1>,
            <p className="form-description" key="form-description">
                {resourceStrings.subscriptionConsentDialog.agreementDescription}
            </p>
        ];
    }

    private renderEmailSubscriptionFields(): JSX.Element {
        if (this.props.subscriptionInfo) {
            return <EmailSubscriptionConsentFormFields
                    subscriptionInfo={this.props.subscriptionInfo}/>
        }
        return null;
    }

    private renderUserAgreementFields(): JSX.Element {
        if (this.props.askUserAgreement) {
            return <UserAgreementConsentFormFields onAgreeToTermsChanged={this.onAgreementChanged} />
        }
        return null;
    }

    public render() {
        if (this.state.enabled) {
            return this.renderBusy();
        }

        return <form key="email-consent-form"
                     className={this.props.subscriptionInfo ? "email-consent-form" : "user-agreement-consent-form"}
                     onSubmit={this.onSubmitClicked}>
            {this.renderHeaderPrefixes()}

            {this.renderEmailSubscriptionFields()}

            {this.renderUserAgreementFields()}

            <div className="form-buttons">
                <button onClick={this.onCancelClicked}>
                    {resourceStrings.subscriptionConsentDialog.cancelButtonLabel}
                </button>
                <span className="spacer">&nbsp;</span>
                <button className="save-button"
                        disabled={!this.state.saveButtonEnabled}
                        onClick={this.onSubmitClicked}>
                    {resourceStrings.subscriptionConsentDialog.saveButtonLabel}
                </button>
            </div>
        </form>;
    }
}


// WEBPACK FOOTER //
// ./Client/Views/EmailSubscriptionConsentForm.tsx